<template>
  <div :class="classes">
    <input
      :id="nameProp"
      ref="input"
      :type="type"
      :value="value"
      @input="onInput"
      :disabled="disabled"
      :class="{ input: true, filled: isFilled }"
      v-mask="mask || ''"
      :maxlength="maxlength"
    />
    <label :for="nameProp" v-text="label"></label>
  </div>
</template>

<script>
export default {
  props: {
    type: String,
    label: String,
    value: String,
    disabled: Boolean,
    name: String,
    mask: String,
    icon: String,
    maxlength: String,
    uppercase: Boolean,
  },
  data() {
    return {
      nameProp: this.name || `input${Math.random()}`,
    };
  },
  computed: {
    classes() {
      const classes = {};
      classes["field"] = true;
      classes["is-uppercase"] = this.uppercase;
      classes["is-danger"] =
        this.$parent.errors.has(this.name) ||
        (this.$parent.$parent && this.$parent.$parent.errors.has(this.name));

      if (this.icon) {
        classes["has-icon"] = true;
        classes[this.icon] = true;
      }

      return classes;
    },

    isFilled() {
      return this.value && this.value.length > 0;
    },
  },
  methods: {
    onInput(event) {
      this.$emit("input", event.target.value, event);
    },
    focus() {
      this.$refs.input.focus();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../assets/sass/variables";

$top: 10px;
$padding: calc(0.375rem - 1px) calc(0.675rem - 1px) calc(0.675rem - 1px)
  calc(2.225rem - 1px);

.field {
  position: relative;
  padding-top: $top;
  background-color: $black;

  &.has-icon {
    background-position: 7px 57%;
    background-repeat: no-repeat;

    &.buddy {
      background-image: $buddyIcon;
    }
    &.email {
      background-image: $emailIcon;
    }
    &.document {
      background-image: $documentIcon;
    }
    &.gift {
      background-image: $giftIcon;
    }
    &.lock {
      background-image: $lockIcon;
    }
    &.wallet {
      background-image: $walletIcon;
    }
    &.calendar {
      background-image: $calendarIcon;
    }
  }

  &.is-uppercase {
    input {
      text-transform: uppercase;
    }
  }

  input,
  input[disabled] {
    color: $white;
    background-color: transparent;
    border-radius: 0;
    border: none;
    border-bottom: 1px $grey-darker solid;
    box-shadow: none !important;
    padding: $padding;

    &[disabled] {
      color: $grey-light;
      background-color: transparent;
    }
  }

  & > label {
    position: absolute;
    top: $top;
    left: 0;
    padding: $padding;
    transition: all 200ms;
    color: $white;
    font-size: 85%;
    text-transform: uppercase;
    cursor: text;
    opacity: 1;
  }

  & > input:focus + label,
  & > input:-webkit-autofill + label,
  & > input.filled + label {
    font-size: 71%;
    transform: translate3d(0, -55%, 0);
    opacity: 0.5;

    cursor: default;
    user-select: none;
  }

  &.is-danger > label {
    color: $red;
    opacity: 1 !important;
  }
}

// Fix autofill color
@-webkit-keyframes autofill {
  to {
    color: $white;
    background: transparent;
  }
}
input:-webkit-autofill {
  -webkit-animation-name: autofill;
  -webkit-animation-fill-mode: both;
}
</style>
